import { fromJS } from "immutable";

// utils
import avatarURL from "../utils/avatarURL";

const prependOptions = fromJS([
	{ id: "self", name: "Employee being reviewed", url: avatarURL("E", 0) },
	{ id: "manager", name: "Employee's Manager", url: avatarURL("EM", 0) },
	{ id: "other", name: "Other Employee", url: avatarURL("OE", 0) },
	{
		id: "manager-manager",
		name: "Manager's Manager",
		url: avatarURL("MM", 0),
	},
	{ id: "direct-reports", name: "Direct Reports", url: avatarURL("DR", 0) },
	{ id: "contributors", name: "Contributors", url: avatarURL("C", 0) },
]);

export const getOptionById = (id) => prependOptions.find((option) => option.get("id") === id);

export default prependOptions;
